import type { ExchangeRefreshToken } from './authTypes';

export interface RefreshTokenRequestOptions {
  refreshToken: string;
  redirectUri: string;
  clientId: string;
  clientSecret: string;
}

export function createRefreshTokenRequest({
  refreshToken,
  redirectUri,
  clientId,
  clientSecret,
}: RefreshTokenRequestOptions): ExchangeRefreshToken {
  return {
    grantType: 'refreshToken',
    responseType: 'token',
    redirectUri,
    clientId,
    clientSecret,
    refreshToken,
  };
}
